import * as types from './mutation-types';

export default {
    [types.SET_ACORDO](state, acordo) {
        state.acordo = acordo;
    },
    [types.SET_ACORDOS](state, acordos) {
        state.acordos = acordos;
    }
}